<template>
    <v-btn
            color="primary"
            class="mr-0"
            :disabled="disabled"
            :dark="!disabled"
            @click="onClick"
    >
        Siguiente
    </v-btn>
</template>
<script>
    export default{
        name: 'ContinueButton',
        props: ['disabled', 'goTo', 'step'],
        methods:{
            onClick(){
                this.goTo(this.step)
            }
        }
    }
</script>

